import { APIKey, FormSectionElements } from "../entities/formTemplateDataType";

export const checkPagination = (entity: any, page = 1, pageSize = 20, sort?: {"sortBy"?: string; "sortOrder"?: string}[]) => {
    if (entity) {
        const pageKeys = Object.keys(entity).filter(key => key.startsWith('page'));
        entity.pagination = {
            page: entity.page || page,
            pageSize: entity.page__size || pageSize,
            sort: entity.sort || sort || [{"sortBy": "Status", "sortOrder": "asc"}]
        }
    } 
    return entity;
}

export const checkUserProf = (entity: any, user: any) => {
    if (user?.email) {
        entity.userId = user.userId || '';
        entity.email = user.email || '';
        entity.firstName = user.firstName || '';
        entity.lastName = user.lastName || '';
    }
    return entity;
}

export const checkSelectedService = (entity: any) => {
    const selectedServiceStr = sessionStorage.getItem('selectedService');
    if (selectedServiceStr) {
        try {
            const selectedService = JSON.parse(selectedServiceStr);
            if (selectedService?.serviceId) {
                entity.service_id = selectedService.serviceId;
            }
            if (selectedService?.serviceName) {
                entity.service_name = selectedService.serviceName;
            }
        } catch (e) {}
    }
    return entity;
}

export const setBaseHeaders = (contentType = "application/json", token: string = null, apiKey: APIKey = null) => {
    let headers = {
        'Content-Type': contentType,
    }
    if (token) {
        const tokenParts = String(token)
            .split(',')
            .map(part => part.trim())
            .filter(Boolean);
        const selectedToken = tokenParts.find(part => /^Bearer\s+/i.test(part)) || tokenParts[0] || '';
        const normalizedToken = selectedToken.replace(/^Bearer\s+/i, '').trim();
        if (normalizedToken) {
            headers['Authorization'] = `Bearer ${normalizedToken}`;
        }
    }
    if (apiKey) {
        headers[apiKey.key] = apiKey.value;
    }
    return headers;
}

export const setBasePayload = (entity: any, language="EN", recaptToken?: string) => {
    if (entity) {
        entity.language = language;
        if (recaptToken) {
            entity.token = recaptToken;
        }
    }
    return entity;
}
